;(function initOpendotsGiftCart() {
  if (window.opendotsGiftCart) return;
  var BUNDLE_LOCK_NOTICE =
    'Gifts and extended warranties are automatically bound to main products and cannot be adjusted separately. Please adjust the quantity of the main product.';
  var isApplyingBundleRows = false;
  var bundleObserver = null;
  var bundleRefreshTimer = null;

  function toPositiveInt(value, fallback) {
    var parsed = parseInt(value, 10);
    if (!Number.isFinite(parsed) || parsed <= 0) return fallback;
    return parsed;
  }

  function buildError(status, errorData, fallbackMessage) {
    var message = (errorData && (errorData.message || errorData.description)) || fallbackMessage;
    return {
      status: Number(status || 422),
      message: message,
      description: message,
    };
  }

  function getLinkedMainVariantIdFromProperties(props) {
    if (!props || typeof props !== 'object') return '';
    if (props['Variant Id']) return String(props['Variant Id']);
    if (props._warranty_main_variant_id) return String(props._warranty_main_variant_id);
    return '';
  }

  function hasLinkedMainVariantProperties(props) {
    return Boolean(getLinkedMainVariantIdFromProperties(props));
  }

  function resolveWarrantyFieldsByMainVariantId(mainVariantId) {
    var resolver = window.getWarrantyFieldValuesByMainVariantId;
    if (typeof resolver !== 'function') return null;
    return resolver(mainVariantId);
  }

  function isWarrantyIdentityByItem(item) {
    var handle = String((item && item.handle) || '').toLowerCase();
    var title = String((item && item.product_title) || '').toLowerCase();
    var sku = String((item && item.sku) || '').trim();
    if (handle.indexOf('shokz-care') >= 0) return true;
    if (title.indexOf('shokz care') >= 0) return true;
    if (sku === 'BOS_365Days' || sku === 'UCS+_365Days' || sku === 'BE_365Days') return true;
    return false;
  }

// 免费延保赠品使用独立商品 handle：shokz-care-extra-1-year-gift。
  function isComplimentaryWarrantyHandle(handle) {
    var normalizedHandle = String(handle || '').toLowerCase();
    return normalizedHandle === 'shokz-care-extra-1-year-gift';
  }

  async function postCartItems(items) {
    var response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ items: items }),
      credentials: 'same-origin',
    });

    var result = await response.json().catch(function () { return {}; });
    return {
      ok: response.ok,
      status: response.status,
      data: result,
    };
  }

  async function postMainItemFromForm(form) {
    var formData = new FormData(form);
    var response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
    });

    var result = await response.json().catch(function () { return {}; });
    return {
      ok: response.ok,
      status: response.status,
      data: result,
    };
  }

  async function addMainItem(mainItem) {
    var variantId = toPositiveInt(mainItem && mainItem.id, 0);
    var quantity = toPositiveInt(mainItem && mainItem.quantity, 1);
    if (!variantId) {
      throw buildError(422, null, '');
    }

    var result = await postCartItems([{ id: variantId, quantity: quantity }]);
    if (!result.ok) {
      throw buildError(result.status, result.data, '');
    }
    return result.data;
  }

  async function addGiftItemSilently(giftItem) {
    var variantId = toPositiveInt(giftItem && giftItem.id, 0);
    var quantity = toPositiveInt(giftItem && giftItem.quantity, 1);
    if (!variantId) return false;
    var properties = giftItem && giftItem.properties && typeof giftItem.properties === 'object' ? giftItem.properties : null;
    var lineItem = {
      id: variantId,
      quantity: quantity,
    };
    if (properties) {
      lineItem.properties = properties;
    }

    try {
      var result = await postCartItems([lineItem]);
      return Boolean(result.ok);
    } catch (error) {
      return false;
    }
  }

  function applyCartUi(cart) {
    if (!cart || !window.jQuery) return;

    var $count = window.jQuery('.CartCount');
    $count.html(cart.item_count);
    if (cart.item_count === 0) {
      $count.addClass('hidden-count');
    } else {
      $count.removeClass('hidden-count');
    }

    var drawerTotal = cart.total_price >= 14000 ? cart.total_price : cart.total_price + 995;
    var moneyFormat = window.theme && window.theme.strings ? window.theme.strings.moneyFormat : null;
    var formatter = window.theme && window.theme.Currency ? window.theme.Currency.formatMoney : null;
    if (formatter && moneyFormat) {
      var formattedTotal = formatter(drawerTotal, moneyFormat);
      window.jQuery('#CartContainer .ajaxcart__subtotal p').html(formattedTotal);
    }

    applyBundleItemRestrictions(cart);
  }

  function ensureBundleLockStyles() {
    if (document.getElementById('opendots-bundle-lock-style')) return;
    var style = document.createElement('style');
    style.id = 'opendots-bundle-lock-style';
    style.textContent =
      '.ajaxcart__row.bundle-linked-row .ajaxcart__qty{opacity:.45;pointer-events:none;}' +
      '.ajaxcart__row.bundle-linked-row .ajaxcart__qty input{pointer-events:none;}' +
      '.ajaxcart__row.bundle-linked-row .cart__remove003{display:none !important;pointer-events:none;}' +
      '.ajaxcart__row .bundle-linked-label{display:block;color:#666;font-size:12px;line-height:1.35;margin-top:4px;}';
    document.head.appendChild(style);
  }

  function getBundleItemTypeFromProperties(props) {
    var properties = props && typeof props === 'object' ? props : {};
    return String(properties._bundle_item_type || '').toLowerCase();
  }

  function getBundleItemLabelFromProperties(props) {
    var properties = props && typeof props === 'object' ? props : {};
    if (properties.bundle_item_label) return String(properties.bundle_item_label);
    var handle = String(properties._benefit_handle || '').toLowerCase();
    var type = getBundleItemTypeFromProperties(properties);
    if (type === 'extended_warranty' || type === 'paid_extended_warranty' || isComplimentaryWarrantyHandle(handle) || Boolean(properties.extended_warranty_product_sku)) {
      return 'Extended Warranty';
    }
    if (type === 'ap_exclusive_gift' || handle === 'shokz-canvas-bag' || handle === 'shokz-dry-towel') return 'AP Exclusive Extra Gift';
    if (type === 'marathon_gift') return 'Marathon Exclusive Gift';
    return 'Regular Complimentary Gift';
  }

  function isExtendedWarrantyItem(props) {
    var properties = props && typeof props === 'object' ? props : {};
    var type = getBundleItemTypeFromProperties(properties);
    var handle = String(properties._benefit_handle || '').toLowerCase();
    return type === 'extended_warranty' || type === 'paid_extended_warranty' || isComplimentaryWarrantyHandle(handle) || Boolean(properties.extended_warranty_product_sku);
  }

  function isPaidExtendedWarrantyItem(props) {
    var properties = props && typeof props === 'object' ? props : {};
    var type = getBundleItemTypeFromProperties(properties);
    var handle = String(properties._benefit_handle || '').toLowerCase();
  // paid_extended_warranty 且不属于免费延保 handle 时，才按正价延保处理。
    return type === 'paid_extended_warranty' && !isComplimentaryWarrantyHandle(handle);
  }

  function isBundleLinkedItem(item) {
    var props = item && item.properties ? item.properties : {};
    if (isPaidExtendedWarrantyItem(props)) return false;
    return props._benefit_linked === 'true' || hasLinkedMainVariantProperties(props);
  }

  function applyBundleItemRestrictions(cart) {
    if (!cart || !window.jQuery) return;
    ensureBundleLockStyles();
    var $container = window.jQuery('#CartContainer');
    if (!$container.length) return;

    isApplyingBundleRows = true;
    $container.find('.ajaxcart__row').removeClass('bundle-linked-row');
    $container.find('.bundle-linked-label').remove();

    var items = Array.isArray(cart.items) ? cart.items : [];
    items.forEach(function (item, index) {
      if (!isBundleLinkedItem(item)) return;
      var line = index + 1;
      var $row = $container.find('.ajaxcart__row[data-line="' + line + '"]');
      if (!$row.length) return;
      $row.addClass('bundle-linked-row');
      if (!isExtendedWarrantyItem(item.properties || {})) return;
      var label = getBundleItemLabelFromProperties(item.properties || {});
      if (!label) return;
      var $nameWrapper = $row.find('.ajaxcart__product-name--wrapper');
      if ($nameWrapper.length && !$nameWrapper.find('.bundle-linked-label').length) {
        $nameWrapper.append('<span class="ajaxcart__product-meta bundle-linked-label">' + label + '</span>');
      }
    });

    window.setTimeout(function () {
      isApplyingBundleRows = false;
    }, 0);
  }

  function validateBundleConsistency(cart) {
    if (!cart || !Array.isArray(cart.items)) return true;
    var items = cart.items;
    var mainVariantCounts = {};
    var linkedGroups = {};
    var expectedApHandleByMainVariant = {};
    var apHandleByProduct = {
      'opendots-2-ap': 'shokz-canvas-bag',
      'opendots-air-ap': 'shokz-dry-towel',
    };

    items.forEach(function (item) {
      var props = item && item.properties ? item.properties : {};
      if (hasLinkedMainVariantProperties(props)) return;
      var variantId = String(item.variant_id || '');
      if (!variantId) return;
      mainVariantCounts[variantId] = (mainVariantCounts[variantId] || 0) + Number(item.quantity || 0);
      var productHandle = String(item.handle || '').toLowerCase();
      if (apHandleByProduct[productHandle]) {
        expectedApHandleByMainVariant[variantId] = apHandleByProduct[productHandle];
      }
    });

    items.forEach(function (item) {
      var props = item && item.properties ? item.properties : {};
      if (isPaidExtendedWarrantyItem(props)) return;
      var linkedVariantId = getLinkedMainVariantIdFromProperties(props);
      if (!linkedVariantId) return;
      if (!linkedGroups[linkedVariantId]) linkedGroups[linkedVariantId] = [];
      linkedGroups[linkedVariantId].push(item);
    });

    var linkedVariantIds = Object.keys(linkedGroups);
    for (var i = 0; i < linkedVariantIds.length; i += 1) {
      var linkedVariantId = linkedVariantIds[i];
      var targetQty = Number(mainVariantCounts[linkedVariantId] || 0);
      var groupItems = linkedGroups[linkedVariantId] || [];
      var complimentaryWarrantyQty = 0;
      var regularGiftQty = 0;
      var marathonGiftQtyByHandle = {};
      var apGiftQtyByHandle = {};
      var hasBundleGiftContext = false;

      groupItems.forEach(function (lineItem) {
        var props = lineItem && lineItem.properties ? lineItem.properties : {};
        var qty = Number(lineItem.quantity || 0);
        var bundleType = String(props._bundle_item_type || '').toLowerCase();
        var benefitHandle = String(props._benefit_handle || '').toLowerCase();
        var isWarranty =
          bundleType === 'extended_warranty' ||
          bundleType === 'paid_extended_warranty' ||
          isComplimentaryWarrantyHandle(benefitHandle) ||
          Boolean(props.extended_warranty_product_sku) ||
          isWarrantyIdentityByItem(lineItem);

        if (isWarranty) {
          complimentaryWarrantyQty += qty;
          hasBundleGiftContext = true;
          return;
        }
        if (bundleType === 'marathon_gift') {
          hasBundleGiftContext = true;
          var marathonKey = benefitHandle || String(lineItem.variant_id || '');
          marathonGiftQtyByHandle[marathonKey] = (marathonGiftQtyByHandle[marathonKey] || 0) + qty;
          return;
        }
        if (bundleType === 'ap_exclusive_gift' || benefitHandle === 'shokz-canvas-bag' || benefitHandle === 'shokz-dry-towel') {
          hasBundleGiftContext = true;
          apGiftQtyByHandle[benefitHandle] = (apGiftQtyByHandle[benefitHandle] || 0) + qty;
          return;
        }
        hasBundleGiftContext = true;
        regularGiftQty += qty;
      });

      if (!hasBundleGiftContext) {
        continue;
      }

      if (targetQty === 0) {
        if (complimentaryWarrantyQty !== 0 || regularGiftQty !== 0) return false;
        var apHandles = Object.keys(apGiftQtyByHandle);
        for (var j = 0; j < apHandles.length; j += 1) {
          if (Number(apGiftQtyByHandle[apHandles[j]] || 0) !== 0) return false;
        }
        continue;
      }

      if (complimentaryWarrantyQty !== targetQty) return false;

      var marathonGiftKeys = Object.keys(marathonGiftQtyByHandle);
      for (var marathonIndex = 0; marathonIndex < marathonGiftKeys.length; marathonIndex += 1) {
        if (Number(marathonGiftQtyByHandle[marathonGiftKeys[marathonIndex]] || 0) !== targetQty) return false;
      }

      if (!marathonGiftKeys.length && regularGiftQty !== targetQty) return false;

      var expectedApHandle = expectedApHandleByMainVariant[linkedVariantId];
      if (expectedApHandle) {
        if (Number(apGiftQtyByHandle[expectedApHandle] || 0) !== targetQty) return false;
      }
    }

    return true;
  }

  function scheduleBundleRowRefresh() {
    if (bundleRefreshTimer) window.clearTimeout(bundleRefreshTimer);
    bundleRefreshTimer = window.setTimeout(function () {
      bundleRefreshTimer = null;
      fetchCartLatest()
        .then(function (cart) {
          if (cart) applyBundleItemRestrictions(cart);
        })
        .catch(function () {});
    }, 120);
  }

  function proceedToCheckout() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') {
      root += '/';
    }
    window.location.assign(root + 'checkout');
  }

  function bindBundleLockGuards() {
    if (!window.jQuery) return;
    if (document.body && document.body.dataset.bundleLockBound === 'true') return;
    if (document.body) document.body.dataset.bundleLockBound = 'true';

    window.jQuery(document).on('click', '.ajaxcart__row.bundle-linked-row .ajaxcart__qty-adjust, .ajaxcart__row.bundle-linked-row .cart__remove003', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.alert(BUNDLE_LOCK_NOTICE);
    });

    window.jQuery(document).on('focus', '.ajaxcart__row.bundle-linked-row .ajaxcart__qty-num', function () {
      this.blur();
      window.alert(BUNDLE_LOCK_NOTICE);
    });

    window.jQuery(document).on('change', '.ajaxcart__row.bundle-linked-row .ajaxcart__qty-num', function () {
      this.blur();
      window.alert(BUNDLE_LOCK_NOTICE);
    });

    window.jQuery(document).on('click', '#CartContainer .cart__checkout, form[action="/cart"] [name="checkout"]', function (event) {
      var button = this;
      if (button.dataset.bundleCheckoutValidating === 'true') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      button.dataset.bundleCheckoutValidating = 'true';

      fetchCartLatest()
        .then(function (cart) {
          return sanitizeBundleProperties(cart);
        })
        .then(function (cart) {
          if (!cart || validateBundleConsistency(cart)) {
            proceedToCheckout();
            return;
          }

          if (typeof window.syncWarrantyWithMainProducts === 'function') {
            var syncRequest = window.syncWarrantyWithMainProducts(cart);
            if (syncRequest && typeof syncRequest.done === 'function') {
              syncRequest
                .done(function () {
                  proceedToCheckout();
                })
                .fail(function () {
                  proceedToCheckout();
                });
              return;
            }
          }

          proceedToCheckout();
        })
        .catch(function () {
          proceedToCheckout();
        })
        .finally(function () {
          delete button.dataset.bundleCheckoutValidating;
        });
    });
  }

  function observeCartContainerMutations() {
    if (bundleObserver) return;
    var container = document.getElementById('CartContainer');
    if (!container || typeof MutationObserver !== 'function') return;
    bundleObserver = new MutationObserver(function () {
      if (isApplyingBundleRows) return;
      scheduleBundleRowRefresh();
    });
    bundleObserver.observe(container, { childList: true, subtree: true });
    scheduleBundleRowRefresh();
  }

  function triggerThemeCartRefresh() {
    if (typeof window.refresh_ajax_cart_state === 'function') {
      try {
        window.refresh_ajax_cart_state();
        return;
      } catch (error) {}
    }

    if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
      try {
        window.ajaxCart.load();
        return;
      } catch (error) {}
    }

    if (window.ShopifyAPI && typeof window.ShopifyAPI.getCart === 'function') {
      try {
        window.ShopifyAPI.getCart(function (cart) {
          applyCartUi(cart);
        });
      } catch (error) {}
    }
  }

  function fetchCartLatest() {
    return fetch('/cart.js?t=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
    }).then(function (response) {
      return response.ok ? response.json() : null;
    });
  }

  function updateCartLineProperties(line, quantity, properties) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        properties: properties,
      }),
    }).then(function (response) {
      return response.ok ? response.json() : null;
    });
  }

  function shallowEqualProperties(a, b) {
    var left = a && typeof a === 'object' ? a : {};
    var right = b && typeof b === 'object' ? b : {};
    var leftKeys = Object.keys(left);
    var rightKeys = Object.keys(right);
    if (leftKeys.length !== rightKeys.length) return false;
    for (var i = 0; i < leftKeys.length; i += 1) {
      var key = leftKeys[i];
      if (!Object.prototype.hasOwnProperty.call(right, key)) return false;
      if (String(left[key] || '') !== String(right[key] || '')) return false;
    }
    return true;
  }

  function buildSanitizedBundleProperties(item) {
    var rawProps = item && item.properties && typeof item.properties === 'object' ? item.properties : {};
    var benefitHandle = String(rawProps._benefit_handle || '').toLowerCase();
    var bundleType = String(rawProps._bundle_item_type || '').toLowerCase();
    var linkedMainVariantId = getLinkedMainVariantIdFromProperties(rawProps);
    var isWarranty =
      bundleType === 'extended_warranty' ||
      bundleType === 'paid_extended_warranty' ||
      isComplimentaryWarrantyHandle(benefitHandle) ||
      Boolean(rawProps.extended_warranty_product_sku) ||
      isWarrantyIdentityByItem(item);

    var sanitized = {};
    if (linkedMainVariantId) {
      sanitized._warranty_main_variant_id = String(linkedMainVariantId);
    }
    if (rawProps._benefit_linked != null && String(rawProps._benefit_linked) !== '') {
      sanitized._benefit_linked = String(rawProps._benefit_linked);
    }
    if (rawProps._benefit_handle != null && String(rawProps._benefit_handle) !== '') {
      sanitized._benefit_handle = String(rawProps._benefit_handle);
    }
    if (rawProps._bundle_item_type != null && String(rawProps._bundle_item_type) !== '') {
      sanitized._bundle_item_type = String(rawProps._bundle_item_type);
    }
    if (rawProps._bundle_locked != null && String(rawProps._bundle_locked) !== '') {
      sanitized._bundle_locked = String(rawProps._bundle_locked);
    }

    if (isWarranty) {
      var mappedWarrantyFields = resolveWarrantyFieldsByMainVariantId(linkedMainVariantId || rawProps['Variant Id']);
      var remarkValue = mappedWarrantyFields && mappedWarrantyFields.remark
        ? String(mappedWarrantyFields.remark)
        : (rawProps.Remark != null ? String(rawProps.Remark) : '');
      var extendedWarrantySku = mappedWarrantyFields && mappedWarrantyFields.extendedWarrantyProductSku
        ? String(mappedWarrantyFields.extendedWarrantyProductSku)
        : (rawProps.extended_warranty_product_sku != null ? String(rawProps.extended_warranty_product_sku) : '');
      if (linkedMainVariantId) {
        sanitized['Variant Id'] = String(linkedMainVariantId);
      } else if (rawProps['Variant Id']) {
        sanitized['Variant Id'] = String(rawProps['Variant Id']);
      }
      if (remarkValue !== '') {
        sanitized.Remark = remarkValue;
      }
      if (extendedWarrantySku !== '') {
        sanitized.extended_warranty_product_sku = extendedWarrantySku;
      }
    }

    return sanitized;
  }

  function sanitizeBundleProperties(cart) {
    if (!cart || !Array.isArray(cart.items)) return Promise.resolve(cart);
    var requests = [];
    cart.items.forEach(function (item, index) {
      if (!item || typeof item !== 'object') return;
      var rawProps = item.properties && typeof item.properties === 'object' ? item.properties : {};
      var hasBundleMarkers =
        hasLinkedMainVariantProperties(rawProps) ||
        rawProps._benefit_linked === 'true' ||
        Boolean(rawProps._benefit_handle) ||
        Boolean(rawProps._bundle_item_type) ||
        Boolean(rawProps.bundle_item_label) ||
        Boolean(rawProps['Variant Id']) ||
        Boolean(rawProps.extended_warranty_product_sku) ||
        isWarrantyIdentityByItem(item);
      if (!hasBundleMarkers) return;

      var sanitized = buildSanitizedBundleProperties(item);
      if (shallowEqualProperties(rawProps, sanitized)) return;
      requests.push(updateCartLineProperties(index + 1, Number(item.quantity || 0), sanitized));
    });

    if (!requests.length) return Promise.resolve(cart);
    return Promise.all(requests)
      .then(function () {
        return fetchCartLatest();
      })
      .then(function (updatedCart) {
        return updatedCart || cart;
      })
      .catch(function () {
        return cart;
      });
  }

  function syncCartUi(options) {
    var config = options || {};
    var skipLegacyGiftSync = Boolean(config.skipLegacyGiftSync);
    var path = (window.location && window.location.pathname ? window.location.pathname : '').toLowerCase();
    var inOpendotsContext =
      path.indexOf('/products/opendots-2') === 0 ||
      path.indexOf('/products/opendots-air') === 0 ||
      path.indexOf('/pages/opendots-series') === 0;

    fetchCartLatest()
      .then(function (cart) {
        if (!cart) return;
        return sanitizeBundleProperties(cart).then(function (normalizedCart) {
          applyCartUi(normalizedCart || cart);
        });
      })
      .catch(function () {});

    triggerThemeCartRefresh();
    setTimeout(triggerThemeCartRefresh, 250);
    setTimeout(function () {
      fetchCartLatest()
        .then(function (cart) {
          if (!cart) return;
          return sanitizeBundleProperties(cart).then(function (normalizedCart) {
            applyCartUi(normalizedCart || cart);
          });
        })
        .catch(function () {});
      triggerThemeCartRefresh();
    }, 800);

    if (!skipLegacyGiftSync && !inOpendotsContext) {
      if (typeof window.scheduleFreeGiftChangeNum === 'function') {
        window.scheduleFreeGiftChangeNum();
      } else if (typeof window.free_gift_change_num === 'function') {
        window.free_gift_change_num();
      }
    }
    scheduleBundleRowRefresh();
  }

  function tryAddPaidWarrantyFromForm(form) {
    if (!form || typeof window.addWarrantyItem !== 'function') return;
    if (!document.querySelector('input[name="warranty-product-single"]:checked')) return;
    var formData = new FormData(form);
    window.addWarrantyItem(
      formData.get('id'),
      formData.get('title'),
      formData.get('option1'),
      formData.get('option2')
    );
  }

  async function addBundle(bundle, options) {
    var config = options || {};
    var mainItem = bundle && bundle.mainItem ? bundle.mainItem : null;
    var giftItems = Array.isArray(bundle && bundle.giftItems) ? bundle.giftItems : [];
    var form = bundle && bundle.form ? bundle.form : null;

    if (!mainItem || !toPositiveInt(mainItem.id, 0)) {
      throw buildError(422, null, '');
    }

    if (
      document.querySelector('input[name="warranty-product-single"]:checked') &&
      typeof window.validateWarrantySelection === 'function' &&
      !window.validateWarrantySelection()
    ) {
      throw buildError(422, null, '');
    }

    var allItems = [mainItem].concat(giftItems);
    var bundleResult = await postCartItems(allItems);
    if (bundleResult.ok) {
      tryAddPaidWarrantyFromForm(form);
      syncCartUi({ skipLegacyGiftSync: config.skipLegacyGiftSync });
      return { mainData: bundleResult.data, usedFallback: false };
    }

    var mainResult;
    if (form) {
      mainResult = await postMainItemFromForm(form);
      if (!mainResult.ok) {
        throw buildError(mainResult.status, mainResult.data, '');
      }
    } else {
      var mainData = await addMainItem(mainItem);
      mainResult = { ok: true, data: mainData };
    }

    if (giftItems.length) {
      await Promise.all(giftItems.map(addGiftItemSilently));
    }

    tryAddPaidWarrantyFromForm(form);
    syncCartUi({ skipLegacyGiftSync: config.skipLegacyGiftSync });
    return { mainData: mainResult.data, usedFallback: true };
  }

  function enqueue(task) {
    var previous = window.__opendotsGiftCartQueue || Promise.resolve();
    var next = previous.catch(function () {}).then(task);
    window.__opendotsGiftCartQueue = next.catch(function () {});
    return next;
  }

  window.opendotsGiftCart = {
    postCartItems: postCartItems,
    postMainItemFromForm: postMainItemFromForm,
    addMainItem: addMainItem,
    addGiftItemSilently: addGiftItemSilently,
    addBundle: addBundle,
    syncCartUi: syncCartUi,
    enqueue: enqueue,
    buildError: buildError,
    validateBundleConsistency: validateBundleConsistency,
  };

  bindBundleLockGuards();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCartContainerMutations);
  } else {
    observeCartContainerMutations();
  }
})();
